import ColorsGallery from './ColorsGallery/ColorsGallery';

export default ColorsGallery;
